/*
  Special Ava PDP bundles priced via a "… Set saving" discount on the Ava line
  (see assets/ava-setting-bundle.js) only get that saving while every bundled
  accessory is still in cart. If the customer reduces or removes accessories,
  swap the Ava set variant for its Standard twin so they pay the Standard price.
*/
(function () {
  if (window.__avaBundleGuard || !window.fetch) return;
  window.__avaBundleGuard = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var timer = null;

  // XHR, not fetch: the Ava PDP patches fetch so cart/add.js replays its last
  // pre-added payload after an ATC, which would swallow the Standard add.
  function request(method, path, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      // Must not be swallowed by the Ava PDP Candy Rack cart/add short-circuit.
      xhr.__avaBypassCandyShortCircuit = true;
      xhr.open(method, root + path, true);
      xhr.setRequestHeader('Accept', 'application/json');
      if (body) xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { resolve(JSON.parse(xhr.responseText)); } catch (e) { resolve(null); }
        } else {
          reject(new Error('Cart request failed: ' + xhr.status));
        }
      };
      xhr.onerror = function () { reject(new Error('Cart request failed')); };
      xhr.send(body ? JSON.stringify(body) : null);
    });
  }

  function post(path, body) {
    return request('POST', path, body);
  }

  function getCart() {
    return request('GET', 'cart.js');
  }

  function linesToSwap(cart) {
    var swaps = [];
    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._ava_bundle_role !== 'main' || !props._ava_bundle_std) return;
      if (String(props._ava_bundle_std) === String(item.variant_id)) return;
      var need = Number(props._ava_bundle_need || 0) * item.quantity;
      var have = 0;
      cart.items.forEach(function (other) {
        var otherProps = other.properties || {};
        if (otherProps._ava_bundle === props._ava_bundle && otherProps._ava_bundle_role === 'accessory') {
          have += other.quantity;
        }
      });
      if (have < need) swaps.push(item);
    });
    return swaps;
  }

  function swapLine(item) {
    var props = {};
    Object.keys(item.properties || {}).forEach(function (key) {
      if (key !== '_ava_bundle_std' && key !== '_ava_bundle_need') props[key] = item.properties[key];
    });
    var standardId = Number(item.properties._ava_bundle_std);
    function hasStandard(cart) {
      return (cart.items || []).some(function (line) {
        return line.variant_id === standardId && (line.properties || {})._ava_bundle === props._ava_bundle;
      });
    }
    return getCart()
      .then(function (cart) {
        var stillThere = (cart.items || []).some(function (line) { return line.key === item.key; });
        if (!stillThere) return null;
        if (hasStandard(cart)) return cart;
        return post('cart/add.js', { items: [{ id: standardId, quantity: item.quantity, properties: props }] }).then(getCart);
      })
      .then(function (cart) {
        if (!cart) return;
        if (!hasStandard(cart)) throw new Error('Standard Ava line was not added');
        return post('cart/change.js', { id: item.key, quantity: 0 });
      });
  }

  function candyRackModalOpen() {
    var frame = document.getElementById('candyrack-frame');
    return !!(frame && frame.offsetParent !== null && frame.offsetHeight > 50);
  }

  function refreshCartUi() {
    // Don't reload under Candy Rack's pre-checkout modal — that aborts CONTINUE → /checkout.
    if (candyRackModalOpen()) return;
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    var detail = { openDrawer: false };
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
  }

  function check() {
    if (running || candyRackModalOpen()) return;
    running = true;
    getCart()
      .then(function (cart) {
        var swaps = linesToSwap(cart);
        if (!swaps.length) return false;
        return swaps
          .reduce(function (chain, item) {
            return chain.then(function () { return swapLine(item); });
          }, Promise.resolve())
          .then(function () { return true; });
      })
      .then(function (changed) {
        running = false;
        if (changed) refreshCartUi();
      })
      .catch(function () {
        running = false;
      });
  }

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(check, 250);
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(window, arguments);
    if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(scheduleCheck, function () {});
    }
    return result;
  };

  if (/\/cart\/?$/.test(window.location.pathname)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
    else check();
  }
})();
